import { motion } from "framer-motion";
import dayjs from "dayjs";
import { PendingActivity } from "./PendingActivities";
import ActivityItem from "./ActivityItem";
import EmptyState from "./EmptyState";
import RescheduleRequest from "components/reschedule-request/RescheduleRequest";
import { faCalendarAlt, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatLeft, canRescheduleAccepted } from "./PendingActivities";
import "./PendingActivities.scss";

const listVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06,
    },
  },
};

interface BookingsTabProps {
  bookings: PendingActivity[];
  loading: boolean;
  showCreatorInfo?: boolean;
  onReschedule?: (activity: PendingActivity) => void;
}

const BookingsTab: React.FC<BookingsTabProps> = ({
  bookings,
  loading,
  showCreatorInfo,
}) => {
  if (bookings.length === 0 && !loading) {
    return (
      <EmptyState
        icon={faCalendarAlt}
        title="No Upcoming Bookings"
        description="This creator doesn't have any confirmed bookings yet. Once they accept invitations or you confirm their applications, they'll appear here."
        actions={
          <>
            <Button
              type="primary"
              onClick={() => {
                /* implement send invitation flow if needed */
              }}
            >
              <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: 8 }} />
              Send Invitation
            </Button>
            <Button
              onClick={() => {
                /* implement add to campaign flow if needed */
              }}
            >
              + Add to Campaign
            </Button>
          </>
        }
      />
    );
  }

  return (
    <motion.div
      className="activity-list bookings-list"
      variants={listVariants}
      initial="hidden"
      animate="visible"
    >
      {bookings.map((booking) => (
        <ActivityItem
          key={booking.id}
          activity={booking}
          showCreatorInfo={showCreatorInfo}
          type="booking"
          renderDateTime={() => (
            <div className="booking-datetime">
              <div className="booking-date">
                {booking.applicationDate
                  ? dayjs
                      .utc(booking.applicationDate?.date)
                      .format("MMMM D, YYYY")
                  : formatLeft((booking as any).details)}
              </div>
              <div className="booking-time">
                {booking.applicationDate?.hour || "-"}
              </div>
            </div>
          )}
          renderActions={() => (
            <>
              {canRescheduleAccepted(booking) &&
                booking.bookingId &&
                booking.collabId && (
                  <RescheduleRequest
                    asButton
                    influencer={{
                      bookingId: booking.bookingId,
                      collabId: booking.collabId,
                      tabStatus: (booking.tabStatus?.toLowerCase() ||
                        "accepted") as "accepted" | "pending" | "rejected" | "expired",
                      isPremium: booking.isPremium,
                      selfManagedCompensationEnabled:
                        booking.selfManagedCompensationEnabled,
                      cashCompAmount: booking.cashCompAmount ?? undefined,
                    }}
                  />
                )}
            </>
          )}
        />
      ))}
    </motion.div>
  );
};

export default BookingsTab;

